var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddInsideCircleBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-3.71547e-07 8.5C-1.66676e-07 13.1869 3.8131 17 8.5 17C13.1869 17 17 13.1869 17 8.5C17 3.8131 13.1869 -5.76418e-07 8.5 -3.71547e-07C3.8131 -1.66676e-07 -5.76418e-07 3.8131 -3.71547e-07 8.5ZM15.8667 8.5C15.8667 12.5619 12.5619 15.8667 8.5 15.8667C4.43813 15.8667 1.13333 12.5619 1.13333 8.5C1.13333 4.43813 4.43813 1.13333 8.5 1.13333C12.5619 1.13333 15.8667 4.43813 15.8667 8.5Z",
    fill: "#556BB8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06563 4.44609L8.06563 8.04609L4.46562 8.04609C4.21722 8.04609 4.01562 8.24724 4.01562 8.49609C4.01562 8.74494 4.21722 8.94609 4.46562 8.94609L8.06563 8.94609L8.06563 12.5461C8.06563 12.7949 8.26723 12.9961 8.51563 12.9961C8.76403 12.9961 8.96563 12.7949 8.96563 12.5461L8.96563 8.94609L12.5656 8.94609C12.814 8.94609 13.0156 8.74494 13.0156 8.49609C13.0156 8.24724 12.814 8.04609 12.5656 8.04609L8.96563 8.04609L8.96563 4.44609C8.96563 4.19724 8.76403 3.99609 8.51563 3.99609C8.26723 3.99609 8.06563 4.19724 8.06563 4.44609Z",
    fill: "#556BB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddInsideCircleBlue);
export default __webpack_public_path__ + "static/media/add-inside-circle-blue.182afbfd6b18a6a9e1068bcd188a3cab.svg";
export { ForwardRef as ReactComponent };